import { RouterLink } from '@angular/router';
import { APP_ROUTES } from '@core/constants/route.constant';

export const DASHBOARD_STATS = [
  { label: 'Enterprises', value: '—', hint: 'Active accounts' },
  { label: 'Incomplete', value: '—', hint: 'Pending onboarding' },
  { label: 'Plans', value: '—', hint: 'Published plans' },
  { label: 'Features', value: '—', hint: 'Enabled features' },
];

export const DASHBOARD_QUICK_LINKS = [
  { label: 'View enterprises', route: APP_ROUTES.ADMIN.ENTERPRICES.ROOT },
  { label: 'Incomplete onboarding', route: APP_ROUTES.ADMIN.ENTERPRICES.INCOMPLETE },
  { label: 'Manage plans', route: APP_ROUTES.ADMIN.PLANS.ROOT },
  { label: 'Manage features', route: APP_ROUTES.ADMIN.FEATURES.ROOT },
];
